import { useEffect, useState } from 'react';
import { isNative, setStatusBarStyle, isIOS } from '@/lib/nativeUtils';

/**
 * Hook to initialize native app features
 * Call this once at the app root level
 */
export const useNativeInit = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    const initNative = async () => {
      if (!isNative) {
        setIsReady(true);
        return;
      }

      try {
        // Initialize Capgo updater
        const { CapacitorUpdater } = await import('@capgo/capacitor-updater');
        await CapacitorUpdater.notifyAppReady();

        // Set status bar style based on system preference
        const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        await setStatusBarStyle(isDarkMode);

        // Hide splash screen after initialization
        const { SplashScreen } = await import('@capacitor/splash-screen');
        await SplashScreen.hide();

        // Add safe area CSS variables for iOS
        if (isIOS()) {
          document.documentElement.style.setProperty(
            '--safe-area-inset-top',
            'env(safe-area-inset-top)'
          );
          document.documentElement.style.setProperty(
            '--safe-area-inset-bottom',
            'env(safe-area-inset-bottom)'
          );
          document.documentElement.style.setProperty(
            '--safe-area-inset-left',
            'env(safe-area-inset-left)'
          );
          document.documentElement.style.setProperty(
            '--safe-area-inset-right',
            'env(safe-area-inset-right)'
          );
        }

      } catch {
        // Native init failure is non-critical — Capacitor WebView continues without it.
      }

      setIsReady(true);
    };

    initNative();
  }, []);

  return { isReady, isNative };
};
